(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/tur/ball/assets/javascripts/ball-vikinglotto.js') >= 0) return;  svs.modules.push('/components/tur/ball/assets/javascripts/ball-vikinglotto.js');
'use strict';

svs.tur = svs.tur || {};
svs.tur.ball = svs.tur.ball || {};
const Events = svs.tur.ball.constants;
class BallVikinglotto extends svs.tur.ball.Default {
  constructor(options) {
    options.productId = 'Vikinglotto';
    super(options);
    this.log = new svs.core.log.Logger('ball.vikinglotto');
  }
  createDomElements() {
    this.$bg = this.createAndAddElement({
      className: 'bg'
    });

    this.$inner = this.createElement('inner');
    this.$number = this.createElement('number', 'span');
    this.setNumber(this.number);
    this.$inner.appendChild(this.$number);
    this.$el.appendChild(this.$inner);
    if (this.extraNumber) {
      const svgQuestionmark = svs.numbergames.rules.utils.vikinglotto.getVikingSymbolSvg('?');
      this.$bg.innerHTML = svgQuestionmark;
    }
  }
  setNumber(number) {
    let symbol = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
    if (number !== undefined) {
      if (number > this.max) {
        this.log.info("You cannot set a higher number (".concat(number, ") than"), this.max);
      } else {
        const isVikinglottoExtraBall = svs.numbergames.productMapping.isVikinglotto(this.productId) && this.extraNumber;
        this._previousNumber = this.number;
        this.number = number;
        this.$el.setAttribute('data-id', number);
        if (isVikinglottoExtraBall) {
          const v = svs.numbergames.rules.utils.vikinglotto;
          this.$number.innerHTML = symbol ? v.getVikingSymbolSvg(symbol) : v.getVikingNumberSvg(number);
        } else {
          this.$number.textContent = number;
        }
        this.trigger(Events.BALL_UPDATED, this);
      }
    }
  }
  classNames() {
    const classNames = ['ball-vikinglotto'];
    if (this.extraNumber) {
      classNames.push('ball-extra-number');
    }
    return classNames;
  }
}
svs.tur.ball.Vikinglotto = BallVikinglotto;

 })(window);